import ImportData from '../../components/admin/ImportData';
import MigrateData from '../../components/admin/MigrateData';

export default function ImportPage() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-6">Data Management</h1>
      
      <div className="space-y-6">
        <ImportData />
        <MigrateData />
      </div>
    </div>
  );
} 